import { createSelector } from "reselect"
import { percentageFormatter, roundPercentageFormatter } from "helpers/formatters/numbers"
import { getModelCategories } from "selectors/modelMetadata"

export const getCategories = createSelector(
  [getModelCategories],
  (categories) => [
    ...categories.map(({ id, label, color, background, singleFactor }) => ({
      id,
      label,
      color,
      background,
      listFactors: true,
      singleFactor,
      formatter: percentageFormatter,
      scaleFormatter: roundPercentageFormatter,
    })), {
      id: "specific",
      label: "Specific",
      color: "#607D8B",
      background: "#EEEEEE",
      formatter: percentageFormatter,
      scaleFormatter: roundPercentageFormatter,
    },
  ],
)
